import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { fetchProductsGroups } from './groups/fetchProductsGroups'
import { getUrlWithVersion } from '../../../api/api'

export const deleteOneProduct = createAsyncThunk<
    { guid: string },
    { guid: string; name: string },
    ThunkConfig<string>
>('productsSlice/deleteOneProduct', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, name } = args

    try {
        await api.delete(getUrlWithVersion(`/products/${guid}`))
        throwSuccessMessage(`Success! ${name} deleted!`)
        dispatch(fetchProductsGroups())

        return { guid }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to delete product')
    }
})
